export default __webpack_public_path__ + "static/media/facebook.cbde6820.svg";